<template>
  <div class="row p-5">
    <span class="color-primary font-medium col-12 center">Quadro geral de avaliações</span>
    <br/>
    <div class="col-12 mt-3 table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr class="font-weight-bold">
            <td class="center">Competência</td>
            <td v-for="reference in references" :key="reference.reference_name" class="center">
              {{reference.reference_name}}
            </td>
            <td class="center">Total</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="skill in skills" :key="skill.id" class="h-auto">
            <th class="center align-middle font-weight-normal" scope="row">
              {{ skill.name }}
            </th>
            <td 
              class="center align-middle"
              v-for="avaliation in skill.avaliations" :key="avaliation.id">
              <StarRating
                active-color="#9472F8"
                v-model="avaliation.rating"
                :read-only="true"
                v-bind:max-rating="5"
                v-bind:star-size="15"
                class="d-inline-block"
              ></StarRating>
            </td>
            <td class="center align-middle">{{skill.total}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import StarRating from "vue-star-rating";

  export default {
    props: [ "apply_id" ],
    components: { StarRating, },
    data: _ => ({
      skills: [],
      references: [],
      total: 0
    }),
    mounted() {
      let url = `/recruiters/candidate_skill_ratings/${this.apply_id}`
      if (top.location.href.indexOf("?account_uid=") > -1) {
        let account_uid = top.location.href.slice(top.location.href.indexOf("?account_uid=") + 13)
        url += `?account_uid=${account_uid}`
      }

      axios
        .get(url)
        .then(response => {
          for(let rating of response.data.ratings) {
            let reference = this.references.find(el => el.reference_name === rating.reference.name)
            if(!reference) {
              this.references.push({
                id: rating.reference_id,
                reference_name: rating.reference.name,
                skills_ids: [],
                ratings: [],
              })
            }

            let skill = this.skills.find(skill => skill.id === rating.skill_id)
            if(skill) continue;
            this.skills.push({
              id: rating.skill_id,
              name: rating.name,
              avaliations: [],
              total: 0,
            })
          }

          for(let index in this.references) {
            for(let rating of response.data.ratings) {
              if(this.references[index].id === rating.reference_id) {
                this.references[index].skills_ids.push(rating.skill_id)
                this.references[index].ratings.push(rating.rating)
              }
            }
          }

          for(let index in this.skills) {
            for(let index_r in this.references) {
              if(this.references[index_r].skills_ids.includes(this.skills[index].id)) {
                let index_skill = this.references[index_r].skills_ids.indexOf(this.skills[index].id)
                this.skills[index].avaliations.push({
                  id: index_r + "selected",
                  rating: this.references[index_r].ratings[index_skill]
                })
              } else this.skills[index].avaliations.push({
                id: index_r + "unique",
                rating: 0,
              })
            }
          }

          this.skills.forEach((skill, index) => skill.avaliations.forEach(av => this.skills[index].total+=av.rating))
        })
    },
  }
</script>